import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.widgets').controller('MultiSelectCtrl', MultiSelectCtrl);

    MultiSelectCtrl.$inject = [];

    function MultiSelectCtrl() {
        var vm = this;

        vm.move = move;

        activate();

        ////////////////////////
        function activate() {
            if (!vm.availableList || !vm.availableList.length) vm.availableList = [];
            if (!vm.selectedList || !vm.selectedList.length) vm.selectedList = [];
        }

        function move(items, from, to) {
            for (var i = 0; i < items.length; i++) {
                var itemIdx = from.indexOf(items[i]);
                if (itemIdx !== -1) {
                    from.splice(itemIdx, 1);
                    to.push(items[i]);
                }
            }
        }
    }
})();
